import { render, staticRenderFns } from "./turrezervasyonodemeler.vue?vue&type=template&id=051e32cc&"
import script from "./turrezervasyonodemeler.vue?vue&type=script&lang=js&"
export * from "./turrezervasyonodemeler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports